// src/apiQuery/useEmitirNfe.ts

import { useMutation } from '@tanstack/react-query';
import api from '../Services/api';
import { INfeRequest, INfeResponse } from '../interfaces/INfe';
import { showError, showSuccess } from './toast';

export const useEmitirNfe = () => {
  return useMutation<INfeResponse, Error, INfeRequest>({
    mutationFn: async (payload: INfeRequest) => {
      const { data } = await api.post<INfeResponse>('/api/v1/nfe/emitir', payload);
      
      // Se existe erro no body, trata como falha
      if (data.body.error) {
        throw new Error(data.body.error);
      }
      
      return data;
    },
    onSuccess: (data) => {
      if (data.body.status === 'aprovado') {
        showSuccess('NFe emitida com sucesso!');
      } else {
        showError(`Erro ao emitir NFe: ${data.body.motivo || 'Erro desconhecido'}`);
      }
    },
    onError: (error: Error) => {
      console.error('Erro ao emitir NFe:', error);
      // Se a mensagem de erro começa com "[", é um erro da API
      if (error.message && error.message.startsWith('[')) {
        showError(`Erro de validação: ${error.message}`);
      } else {
        showError('Erro ao emitir nota fiscal. Tente novamente.');
      }
    },
  });
};